import { Link } from 'react-router-dom';
import { Section } from '../common/Section';
import { Eyebrow } from '../common/Eyebrow';
import { SplitHeading } from '../animation/SplitHeading';
import { Reveal } from '../animation/Reveal';
import { Icon } from '../common/Icon';
import { cn } from '../../lib/cn';
import { useGalleryPreview } from '../../hooks';

const layout = ['row-span-2', '', '', 'row-span-2', '', ''];

export function GalleryPreview() {
  const { data } = useGalleryPreview(6);
  const items = data?.items ?? [];
  const placeholder = data?.placeholder ?? false;
  // Live photo-backed events when published; branded placeholder tiles until then (matches design).
  if (!items.length) return null;

  return (
    <Section className="section bg-canvas" containerClassName="">
      <div className="mb-10 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div className="max-w-xl">
          <Eyebrow>On the ground</Eyebrow>
          <SplitHeading as="h2" text="Out in the field with farmers and retailers." className="mt-4 font-display text-h1 font-semibold text-ink" />
        </div>
        <Reveal y={16}>
          <Link to="/gallery" className="link-underline inline-flex items-center gap-2 font-semibold text-brand-600">
            View gallery <Icon name="ArrowRight" className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>

      <Reveal className="grid auto-rows-[150px] grid-cols-2 gap-3 md:auto-rows-[180px] md:grid-cols-4" stagger={0.08} y={26}>
        {items.map((item, i) => (
          <Link
            key={item.id}
            to={`/gallery/${item.id}`}
            className={cn('group relative overflow-hidden rounded-lg bg-sand-100', layout[i])}
            aria-label={`${item.title} — open gallery`}
          >
            {item.src ? (
              <img
                src={item.src}
                alt={item.title}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-premium group-hover:scale-105"
              />
            ) : (
              <span className="flex h-full w-full items-center justify-center text-ink-300">
                <Icon name="Sprout" className="h-8 w-8" />
              </span>
            )}
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/0 to-black/0 opacity-80" />
            <div className="absolute inset-x-0 bottom-0 p-4">
              <p className="text-xs font-semibold text-white/70">{item.title}</p>
            </div>
          </Link>
        ))}
      </Reveal>
      {placeholder && (
        <p className="mt-4 text-xs text-ink-500">
          Gallery imagery shown here uses branded placeholders pending real event photography.
        </p>
      )}
    </Section>
  );
}
